import React, { Component } from 'react'
import './Input.scss'

class InputField extends Component {
  static defaultProps = {
    input: { value: '', onChange: () => null },
    meta: {},
    type: 'text',
  }

  render() {
    const {
      input,
      placeholder,
      disabled = false,
      meta: { touched, error },
      type,
      className,
      label,
    } = this.props
    return (
      <div className={`md-field ${className ? className : ''}`}>
        {label && (
          <label
            style={{
              display: 'block',
              textTransform: 'capitalize',
            }}
          >
            {label}
          </label>
        )}
        <input
          {...this.props}
          value={this.props.input.value}
          onChange={this.props.input.onChange}
          onFocus={this.props.input.onFocus}
          onBlur={this.props.input.onBlur}
          className="form-control"
          style={inputStyle}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
        />
        {touched && error && <span className="error">{error}</span>}
      </div>
    )
  }
}

const inputStyle = {
  borderColor: '#d9d9d9 ',
  height: 40,
  minHeight: 'unset',
}
export default InputField
